// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2newt","question":"styles_question__3igtA","description":"styles_description__oIYXA"};